// extracted by mini-css-extract-plugin
module.exports = {"slMapPage":"GeonameMap_slMapPage__qGL_9","slRightRail":"GeonameMap_slRightRail__u8VVo","slLeftRail":"GeonameMap_slLeftRail__F7Hlk","spinner":"GeonameMap_spinner__PWizi"};